module.exports = __webpack_public_path__ + "img/ic_nav_back.c6ee0ee5.svg";